import { Backdrop, CircularProgress, Fade } from '@mui/material'
import { format } from 'date-fns';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../setup';
import { KTSVG } from '../../../../_metronic/helpers';
import { CountryOptions } from '../../../data/CountryOptions';
import { UserModel } from '../../../modules/auth/models/UserModel';
import ZipcodesWithCountry from '../../LTLandVolumeTLPages/ZipcodesWithCountry';
import { modalStyles } from '../../ModalStyles';
import PhoneInput from '../PhoneInput';
import axios from 'axios';
import { EditModalProps } from '../../../pages/shipping-locations/models';
import '../PhoneInput.css'
import '../antd.css'
import moment from 'moment'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import * as Yup from 'yup'
import { DivPaperStyled, ModalStyled, Scroll, SmallTextItalic } from '../../Modals.styled';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import { getCountriesWithoutZipcodes } from '../../../constants/countries';
import TimeInput from '../../TimeInput/TimeInput';
import { formatPhone } from '../../../helpers/formatPhone';
import { formatPhoneUSA } from '../../../helpers/formatPhoneUSA';
import { clearDialCode } from '../../../helpers/clearDialCode';
import { InputStyled } from '../../Inputs.styled';
import SearchShippingLocation from '../../NewBookingPage/SearchShippingLocation';

const SHIPPINGLOCATION = '/api/v1/database/shippinglocation'
const CONVERT_WORDS = 'api/v1/tools/usps/abbreviation'
const COLLECTSL = '/api/v1/collectbilltodata'

const EditOrAddModal = ({open, setOpen, rowSelected, setRowSelected, getData, addOrEdit, setBillToData, collectData}: EditModalProps) => {
    const dispatch = useDispatch()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const [savingCollect, setSavingCollect] = useState(false)
    const [savedColect, setSavedCollect] = useState(false)
    const [updatedCollect, setUpdatedCollect] = useState(false)
    const [currentIdRowToEdit, setCurrentIdRowToEdit] = useState()
    const [zipcode, setZipcode] = useState('')
    const [zipcodeLocal, setZipcodeLocal] = useState('')
    const [shippingLocation, setShippingLocation] = useState()
    const [shippingLocationLocal, setShippingLocationLocal] = useState('')
    const [addOrEditLocal, setAddOrEditLocal] = useState(addOrEdit)
    const [openRemarksMessageModal, setOpenRemarksMessageModal] = useState(false)
    const [city, setCity] = useState({
        City: "",
        Country: "US",
        Name: "",
        State: "",
        Zipcode: "",
        isSL: false,
        isZipcode: false,
        id: null
    })
    const [openTime, setOpenTime] = useState(null)
    const [closeTime, setCloseTime] = useState(null)
    const [errorLocal, setErrorLocal] = useState({
        from: false,
        to: false
    })
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = modalStyles({fontSize: fontSize})
    const [searchTerm, setSearchTerm] = useState('')

    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            if(addOrEdit === 'edit'){
                setRowSelected({})
            }else{
                if(!collectData) {
                    formik.handleReset(initialValues)
                    formik.setValues(initialValues)
                    setBillToData(initialValues)
                }
            }
        }, 500);
    }

    const initialValues = {
        name: '',
        code: '',
        address: '',
        address1: '',
        address2: '',
        country: 'US',
        city: '',
        state: '',
        zipcode: '',
        phone: null,
        fax: null,
        contact: '',
        contactPhone: null,
        email: '',
        open: null,
        close: null,
        remarks: '',
        alertUser: false
    }

    Yup.addMethod<Yup.StringSchema>(Yup.string, "notInvalid", function (message) {
        return this.test("test-name", message, function(value: any) {
          const { path, createError } = this
          return value !== 'Invalid date' ? true : createError({message, path})
        })
    })

    const validationSchema = Yup.object().shape({
        phone: (Yup.string() as any).nullable(true).test("validPhoneNumber", "Invalid phone", (value) => {
            if(value === null || value == undefined){
                return true
            }else if(typeof value === 'string'){
                if(isPossiblePhoneNumber(value)){
                    return true
                }else{
                    return false
                }
            }
        }),
        fax: (Yup.string() as any).nullable(true).test("validPhoneNumber", "Invalid phone", (value) => {
            if(value === null || value == undefined){
                return true
            }else if(typeof value === 'string'){
                if(isPossiblePhoneNumber(value)){
                    return true
                }else{
                    return false
                }
            }
        }),
        contactPhone: (Yup.string() as any).nullable(true).test("validPhoneNumber", "Invalid phone", (value) => {
            if(value === null || value == undefined){
                return true
            }else if(typeof value === 'string'){
                if(isPossiblePhoneNumber(value)){
                    return true
                }else{
                    return false
                }
            }
        }),
        name: Yup.string().required('Name is required'),
        open: (Yup.string() as any).notInvalid().nullable(),
        close: (Yup.string() as any).notInvalid().nullable(),
        city: addOrEditLocal === 'collectLocation' ? Yup.string().required("Required") : Yup.string(),
        zipcode: addOrEditLocal === 'collectLocation'
            ? Yup.string().when('country', {
                is: (country: string) => !getCountriesWithoutZipcodes().includes(country),
                then: Yup.string().required('Required'),
                otherwise: Yup.string().nullable()
            })
            : Yup.string(),
    })

    const formatCollectData = (shippingLocation) => {
        return (
        {
                name: shippingLocation.name,
                code: shippingLocation?.code,
                address1: shippingLocation?.address1,
                address2: shippingLocation?.address2,
                country: CountryOptions?.find(c => c.CodePrimus === shippingLocation?.country)?.Code || 'US',
                city: shippingLocation?.city,
                state: shippingLocation?.state,
                zipcode: shippingLocation?.zipcode,
                phone: formatPhone(shippingLocation.phone, shippingLocation?.country),
                fax: formatPhone(shippingLocation.fax, shippingLocation?.country),
                contact: shippingLocation?.contact,
                contactPhone: formatPhone(shippingLocation.contactPhone, shippingLocation?.country),
                email: shippingLocation?.email,
                open: null,
                close: null,
                remarks: '',
                alertUser: false,
                id: shippingLocation?.id
            }
        )
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        onSubmit: (values) => {
            if(addOrEdit == 'collectLocation') {
                // addOrEditSL(values)
                addSLCollect(values)
            }
            else {
                addOrEditSL(values)
            }
        }
    })
    
    useEffect(() => {
        if(addOrEdit === 'edit'){
            formik.setValues({
                name: rowSelected.name,
                code: rowSelected.code,
                address: rowSelected.address,
                address1: rowSelected.address1,
                country: rowSelected?.country,
                city: rowSelected.city,
                state: rowSelected.state,
                zipcode: rowSelected.zipcode,
                phone: formatPhone(rowSelected.phone, rowSelected?.country) || null,
                fax: formatPhone(rowSelected.fax, rowSelected?.country) || null,
                contact: rowSelected.contact,
                contactPhone: formatPhone(rowSelected.contactPhone, rowSelected?.country) || null,
                email: rowSelected.email,
                open: rowSelected.opentime,
                close: rowSelected.closetime,
                remarks: rowSelected.remarks,
                alertUser: rowSelected.alertUser
            })
            setCity({
                ...city,
                Country: CountryOptions?.find(c => c.CodePrimus === rowSelected?.country)?.Code || 'US',
                City: rowSelected.city,
                State: rowSelected.state,
                Zipcode: rowSelected.zipcode,
                isZipcode: true,
                id: null
            })
            setOpenTime(rowSelected.opentime ? moment(rowSelected.opentime, 'HH:mm') : null)
            setCloseTime(rowSelected.closetime ? moment(rowSelected.closetime, 'HH:mm') : null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowSelected])

    useEffect(() => {
        formik.setFieldValue('country', city?.Country)
        formik.setFieldValue('city', city.City)
        formik.setFieldValue('state', city.State)
        formik.setFieldValue('zipcode', city.Zipcode)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [city])

    useEffect(() => {
        if(!open) {
            setAddOrEditLocal(addOrEdit)
        }
        if(open && addOrEdit === 'add') {
            formik.resetForm()
            setCity({ City: "", Country: "US", Name: "", State: "", Zipcode: "", isSL: false, isZipcode: false, id: null })
            setZipcodeLocal('')
            setShippingLocation(undefined)
            setShippingLocationLocal('')
            setOpenTime(null)
            setCloseTime(null)
        }
        if(open && addOrEdit == 'collectLocation' && collectData) {
            setShippingLocationLocal(collectData?.name) 

            setCity({
                ...city,
                Country: CountryOptions?.find(c => c.CodePrimus === collectData?.country)?.Code || 'US',
                City: collectData?.city,
                State: collectData?.state,
                Zipcode: collectData?.zipcode,
                isZipcode: true,
                id: null
            })
            setShippingLocation({
                ...collectData,
                country: collectData?.country,
                literal: `${collectData.name}. ${collectData?.city}, ${collectData?.state} ${collectData?.zipcode}`,
                postalCode: collectData?.zipcode,
                stateCode: collectData?.state,
                cityAlias: collectData?.city,
                name: collectData?.name,
                isSL: true
            })

            if(collectData?.id) {
                axios.get(COLLECTSL, {
                    params: { name: collectData.name }
                })
                .then((results) => {
                    let result = results.data.data.results.find(r => r.id === collectData.id)
                    if(result) {
                        formik.setValues(formatCollectData(result))
                        setBillToData(formatCollectData(result))
                    }
                }).catch(error => {
                    checkErrorAPICall(error, dispatch, 'Shipping Locations')
                })
            }       
        }
    }, [open])

    useEffect(() => {
        if(addOrEdit == 'collectLocation' && shippingLocation) {
            // let currentSl = 
            // setBillToData(formatCollectData(shippingLocation))            
            formik.setValues(formatCollectData(shippingLocation))
            setCity({
                ...city,
                Country: CountryOptions?.find(c => c.CodePrimus === shippingLocation?.country)?.Code || 'US',
                City: shippingLocation?.city,
                State: shippingLocation?.state,
                Zipcode: shippingLocation?.zipcode,
                isZipcode: true,
                id: null
            })
            // setShippingLocationLocal
        }
    }, [shippingLocation])

    const addOrEditSL = (values) => {        
        setSaving(true)
        let currentSelected = rowSelected ? rowSelected?.id : currentIdRowToEdit
        axios({
            method: (addOrEditLocal === 'add' || addOrEditLocal === 'collectLocation')  ? 'post' : 'put',
            url: (addOrEditLocal === 'add' || addOrEditLocal === 'collectLocation') ? SHIPPINGLOCATION : `${SHIPPINGLOCATION}/${currentSelected}`,
            data: {
                code: values.code,
                name: values.name,
                address: values.address,
                address1: values.address1,
                // address2: values.address2,
                phone: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.phone, (rowSelected?.country || formik.values.country)) : clearDialCode(values.phone || null, (rowSelected?.country || formik.values.country)),
                fax: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.fax, (rowSelected?.country || formik.values.country)) : clearDialCode(values.fax || null, (rowSelected?.country || formik.values.country)),
                email: values?.email || "",
                city: values.city,
                state: values.state,
                country: values?.country,
                zipcode: values.zipcode,
                active: rowSelected?.active === false || rowSelected?.active === true ? rowSelected?.active : true,
                contact: values.contact,
                contactPhone: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.contactPhone, (rowSelected?.country || formik.values.country)) : clearDialCode(values.contactPhone|| null, (rowSelected?.country || formik.values.country)),
                opentime: values.open || "",
                closetime: values.close || "",
                remarks: values.remarks,
                alertUser: values.alertUser
            }
        }).then((response) => {            
            setAddOrEditLocal('edit')
            if(response?.data?.data) {
                setCurrentIdRowToEdit(response?.data?.data?.results?.id)
            }
            setSaving(false)
            setSaved(true)
            setTimeout(function(){
                setSaved(false)
            }, 2000);
            getData({})
            // setOpen(false)
        }).catch(error => {
            setSaving(false)
            checkErrorAPICall(error, dispatch, `${addOrEdit} Shipping Location`)
        })
    }

    const addSLCollect = (values) => {
        setSavingCollect(true)
        
        if(values.id) {
            setUpdatedCollect(true)
        }
        // let currentSelected = values.id ? rowSelected?.id : currentIdRowToEdit
        axios({
            method: values.id  ? 'put' : 'post',
            url: values.id ? `${COLLECTSL}/${values.id}` : COLLECTSL,
            data: {
                code: values.code,
                name: values.name,
                address1: values.address1,
                address2: values.address2,
                // address2: values.address2,
                phone: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.phone, (rowSelected?.country || formik.values.country)) : clearDialCode(values.phone || null, (rowSelected?.country || formik.values.country)),
                fax: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.fax, (rowSelected?.country || formik.values.country)) : clearDialCode(values.fax || null, (rowSelected?.country || formik.values.country)),
                email: values?.email || "",
                city: values.city,
                state: values.state,
                country: values?.country,
                zipcode: values.zipcode,
                active: rowSelected?.active === false || rowSelected?.active === true ? rowSelected?.active : true,
                contact: values.contact,
                contactPhone: values?.country === 'US' || values?.country === 'CA' ? formatPhoneUSA(values.contactPhone, (rowSelected?.country || formik.values.country)) : clearDialCode(values.contactPhone|| null, (rowSelected?.country || formik.values.country)),
                opentime: values.open || "",
                closetime: values.close || "",
                remarks: values.remarks,
                alertUser: values.alertUser
            }
        }).then((response) => {            
            setAddOrEditLocal('edit')
            if(response?.data?.data) {
                setCurrentIdRowToEdit(response?.data?.data?.results?.id)
                setBillToData(formatCollectData(response?.data?.data?.results))            
                formik.setValues(formatCollectData(response?.data?.data?.results))
                formik.setFieldValue('billToData.zipcode', response?.data?.data?.results?.zipcode)
            }
            else {
                setBillToData(formatCollectData(values))
            }
            
            setSavingCollect(false)
            setSavedCollect(true)

            setTimeout(function(){
                setSavedCollect(false)
                setOpen(false)
                if(values.id) {
                    setUpdatedCollect(false)
                }
            }, 2000);
            
            // getData({})
            // setOpen(false)
        }).catch(error => {
            setSavingCollect(false)
            checkErrorAPICall(error, dispatch, `${addOrEdit} Collect Shipping Location`)
        })
    }

    const convertWords = (name, textToConvert) => {
        if(textToConvert){
            axios.get(CONVERT_WORDS, {
                params: {
                    address: textToConvert
                }
            }).then((results) => {
                formik.setFieldValue(name, results.data.data.results.abbreviation)
            })
        }
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            let name = searchTerm.split('-')[1]
            if(searchTerm){
                convertWords(name, formik.values[name])
            }
          // Send Axios request here
        }, 2000)

        if(searchTerm === ''){
            clearTimeout(delayDebounceFn)
        }
    
        return () => clearTimeout(delayDebounceFn)
    }, [searchTerm])
     
    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <DivPaperStyled className={classes.paperEditModalSL}>
                    <div className="row modal-header p-0 pb-2">
                        <div className="col-8">
                            {addOrEdit !== 'collectLocation' && (
                                <h5 className="modal-title">{addOrEdit === 'add' ? 'Add New Shipping Location' : 'Edit Shipping Location'}
                                </h5>
                            )}
                            {addOrEdit == 'collectLocation' && (
                                <h5 className="modal-title">Freight Bill To</h5>
                            )}
                        </div>
                        <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={handleClose}>
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                        <>
                            <Scroll>
                                <div className="row align-items-center mb-7 mt-5">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Name</label>
                                    </div>
                                    {addOrEdit !== 'collectLocation' && (
                                        <div className="col-12 col-sm-7 mb-7 mb-sm-0">
                                            <InputStyled
                                                type="text"
                                                className="form-control"
                                                autoComplete='off'
                                                {...formik.getFieldProps('name')}
                                                style={{ 
                                                    borderColor: formik?.errors?.name && formik?.touched?.name ? '#F1416C' : '#E4E6EF'
                                                }}
                                                fontSize={fontSize}
                                            />
                                            {
                                                formik?.errors?.name && formik?.touched?.name &&
                                                <small className='text-danger'>{formik?.errors.name}</small>
                                            }
                                        </div>
                                    )}
                                    {addOrEdit == 'collectLocation' && (
                                        <div className={`${addOrEdit !== 'collectLocation' ? 'col-sm-7': 'col-sm-12'} col-12 mb-7 mb-sm-0`}>
                                            <SearchShippingLocation
                                                formik={formik}
                                                name='name'
                                                formFor={'collect'}
                                                zipcode={zipcode}
                                                setZipcode={setZipcode}
                                                setZipcodeLocal={setZipcodeLocal}
                                                shippingLocation={shippingLocation}
                                                setShippingLocation={setShippingLocation}
                                                shippingLocationLocal={shippingLocationLocal}
                                                setShippingLocationLocal={setShippingLocationLocal}
                                                disabled={false}
                                                error={formik.errors.name}
                                                // setOpenClearRateToEditModal={setOpenClearRateToEditModal}
                                                // newValuesWhenRateCleared={newValuesWhenRateCleared}
                                                // setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
                                                setOpenRemarksMessageModal={setOpenRemarksMessageModal}
                                            />
                                            {formik.touched.name && formik.errors.name ? <small className="text-danger ms-2 mt-1">Required</small> : null}
                                        </div>
                                    )}
                                    {addOrEdit !== 'collectLocation' && (
                                        <>
                                            <div className="col-12 col-sm-1">
                                                <label className='form-label'>Code</label>
                                            </div>
                                            <div className="col-12 col-sm-3">
                                                <InputStyled
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    {...formik.getFieldProps('code')}
                                                    fontSize={fontSize}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="row align-items-center mb-7">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Address</label>
                                    </div>
                                    {addOrEdit !== 'collectLocation' && (
                                        <>
                                        <div className="col-12 col-sm-7 mb-7 mb-sm-0">
                                            <InputStyled
                                                type="text"
                                                className="form-control"
                                                autoComplete='new-password'
                                                {...formik.getFieldProps('address')}
                                                fontSize={fontSize}
                                                onChange={(e) => {
                                                    setSearchTerm(`${e.target.value}-address`)
                                                    formik.setFieldValue(`address`, e.target.value)
                                                }}
                                                onBlur={(e) => {
                                                    setSearchTerm('')
                                                    convertWords('address', e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-4">
                                            <InputStyled
                                                type="text"
                                                className="form-control"
                                                autoComplete='new-password'
                                                {...formik.getFieldProps('address1')}
                                                fontSize={fontSize}
                                                onChange={(e) => {
                                                    setSearchTerm(`${e.target.value}-address1`)
                                                    formik.setFieldValue(`address1`, e.target.value)
                                                }}
                                                onBlur={(e) => {
                                                    setSearchTerm('')
                                                    convertWords('address1', e.target.value)
                                                }}
                                            />
                                        </div>
                                        </>
                                    )}
                                    {addOrEdit == 'collectLocation' && (
                                        <>
                                        <div className="col-12 col-sm-7 mb-7 mb-sm-0">
                                            <InputStyled
                                                type="text"
                                                className="form-control"
                                                autoComplete='new-password'
                                                {...formik.getFieldProps('address1')}
                                                fontSize={fontSize}
                                                onChange={(e) => {
                                                    setSearchTerm(`${e.target.value}-address1`)
                                                    formik.setFieldValue(`address1`, e.target.value)
                                                }}
                                                onBlur={(e) => {
                                                    setSearchTerm('')
                                                    convertWords('address1', e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-4">
                                            <InputStyled
                                                type="text"
                                                className="form-control"
                                                autoComplete='new-password'
                                                {...formik.getFieldProps('address2')}
                                                fontSize={fontSize}
                                                onChange={(e) => {
                                                    setSearchTerm(`${e.target.value}-address2`)
                                                    formik.setFieldValue(`address2`, e.target.value)
                                                }}
                                                onBlur={(e) => {
                                                    setSearchTerm('')
                                                    convertWords('address2', e.target.value)
                                                }}
                                            />
                                        </div>
                                        </>
                                    )}
                                </div>
                                <div className="row align-items-center mb-7">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>C&#8204;ity</label>
                                    </div>
                                    <div className="col-12 col-sm-11">
                                        <ZipcodesWithCountry
                                        valueName={'billToData'}
                                        zipcodeLocal={zipcodeLocal}
                                        setZipcodeLocal={setZipcodeLocal}
                                        setDataFormik={formik.setFieldValue}
                                        data={city}
                                        setData={setCity}
                                        countryOptions={CountryOptions}
                                        userData={user}
                                        error={formik?.errors.zipcode}
                                        touched={formik?.touched.zipcode}
                                        setFieldTouched={formik.setFieldTouched}
                                        forNewBooking={true}
                                        formFor={'collect'}
                                        disabled={false}
                                        // setOpenClearRateToEditModal={setOpenClearRateToEditModal}
                                        formikValues={formik.values}
                                        mode={null}
                                        setFieldError={formik.setFieldError}
                                        shippingLocation={shippingLocation}
                                        setShippingLocation={setShippingLocation}
                                        editSL={true}
                                    />
                                    </div>
                                </div>
                                <div className="row align-items-center mb-7">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Phone</label>
                                    </div>
                                    <div className="col-12 col-sm-5 mb-7 mb-sm-0">
                                        <PhoneInput
                                            value={formik.values.phone}
                                            setDataFormik={formik.setFieldValue}
                                             {...formik.getFieldProps('phone')}
                                             error={formik.errors?.phone && formik.touched?.phone}
                                            name='phone'
                                            countryCode={formik.values?.country}
                                            deleteSelectCountry={false}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Fax</label>
                                    </div>
                                    <div className="col-12 col-sm-5">
                                        <PhoneInput
                                            value={formik.values.fax}
                                            setDataFormik={formik.setFieldValue}
                                            {...formik.getFieldProps('fax')}
                                            name='fax'
                                            error={formik.errors?.fax && formik.touched?.fax}
                                            countryCode={formik.values?.country}
                                            deleteSelectCountry={false}
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center mb-7">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Contact</label>
                                    </div>
                                    <div className="col-12 col-sm-5 mb-7 mb-sm-0">
                                        <InputStyled
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            {...formik.getFieldProps('contact')}
                                            fontSize={fontSize}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Phone</label>
                                    </div>
                                    <div className="col-12 col-sm-5">
                                        <PhoneInput
                                            value={formik.values.contactPhone}
                                            setDataFormik={formik.setFieldValue}
                                            {...formik.getFieldProps('contactPhone')}
                                            error={formik.errors?.contactPhone && formik.touched?.contactPhone}
                                            name='contactPhone'
                                            countryCode={formik.values.country}
                                            deleteSelectCountry={false}
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center mb-7">
                                    <div className="col-12 col-sm-1">
                                        <label className='form-label'>Email</label>
                                    </div>
                                    <div className="col-12 col-sm-11 mb-7 mb-sm-0">
                                        <InputStyled
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            {...formik.getFieldProps('email')}
                                            fontSize={fontSize}
                                        />
                                    </div>
                                </div>
                                {addOrEdit !== 'collectLocation' && (
                                    <>
                                        <div className="row align-items-center">
                                            <div className="col-12 col-sm-1">
                                                <label className='form-label'>Hours</label>
                                            </div>
                                            <div className="col-12 col-sm-11">
                                                <div className="row align-items-center">
                                                    <div className="col-12 col-sm-1">
                                                        <label className='form-label'>Open</label>
                                                    </div>
                                                    <div className="col-12 col-sm-5">
                                                        <TimeInput
                                                            error={formik.errors?.open && formik.touched?.open}
                                                            data={openTime}
                                                            setData={setOpenTime}
                                                            name="open"
                                                            setFormikData={formik.setFieldValue}
                                                            errorLocal={errorLocal}
                                                            setErrorLocal={setErrorLocal}
                                                            time='from'
                                                        />
                                                    </div>
                                                    <div className="col-12 col-sm-1">
                                                        <label className='form-label'>Close</label>
                                                    </div>
                                                    <div className="col-12 col-sm-5">
                                                        <TimeInput
                                                            error={formik.errors?.close && formik.touched?.close}
                                                            data={closeTime}
                                                            setData={setCloseTime}
                                                            name="close"
                                                            setFormikData={formik.setFieldValue}
                                                            errorLocal={errorLocal}
                                                            setErrorLocal={setErrorLocal}
                                                            time='to'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row align-items-center mb-7">
                                            <div className="col-12 col-sm-1 mb-3 mb-sm-0">
                                            </div>
                                            <div className="col-12 col-sm-11">
                                                <div className="row align-items-center">
                                                    <div className="col-12 col-sm-1">
                                                    </div>
                                                    <div className="col-12 col-sm-5 mb-7 mb-sm-0">
                                                        <small className="text-danger">{((formik.errors?.open && formik.touched?.open) || errorLocal.from) && 'Invalid time'}</small>
                                                    </div>
                                                    <div className="col-12 col-sm-1">
                                                    </div>
                                                    <div className="col-12 col-sm-5">
                                                        <small className="text-danger">{((formik.errors?.close && formik.touched?.close) || errorLocal.to) && 'Invalid time'}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row align-items-center mb-7">
                                            <div className="col-12 col-md-1">
                                                <label className='form-label'>Remarks</label>
                                            </div>
                                            <div className="col-12 col-md-11">
                                                <textarea
                                                    style={{height: 60}}
                                                    className="form-control"
                                                    rows={2}
                                                    autoComplete='off'
                                                    {...formik.getFieldProps('remarks')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-0 col-md-1"></div>
                                            <div className="col-11">
                                                <div className="form-check form-check-custom form-check-solid">
                                                    <input className="form-check-input" type="checkbox" id="alertUser" {...formik.getFieldProps('alertUser')} checked={formik.getFieldProps('alertUser').value}/>
                                                    <label className="form-check-label" htmlFor="alertUser">
                                                        Show remarks when selecting
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Scroll>
                            <div className="row mb-3 mt-7">
                                <div className="col-12 col-sm-8 mb-7 mb-sm-0 d-flex align-items-center">
                                    {addOrEdit === 'edit' && <SmallTextItalic>*Created on {format(new Date(rowSelected?.dateSaved || null), 'MM/dd/yyyy')} by {rowSelected?.createdByUser}</SmallTextItalic>}
                                </div>
                                <div className="col-12 col-md-12 d-flex justify-content-end">
                                    <button
                                        className="btn btn-secondary me-4"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                    {addOrEdit !== 'collectLocation' && (
                                        <button
                                            className={`btn ${saved ? 'btn-success' : 'btn-primary'} d-flex align-items-center`}
                                            style={{
                                                cursor: saved ? 'auto' : 'pointer',
                                                transition: 'background-color 0.5s ease'
                                            }}
                                            type='submit'
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                        >
                                            {saving ? 'Saving' : saved ? 'Saved' : 'Save'}{saving && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                        </button>
                                    )}
                                    {addOrEdit == 'collectLocation' && (
                                        <>
                                        <button
                                            className={`btn ${savedColect || updatedCollect ? 'btn-success' : 'btn-primary'} d-flex align-items-center`}
                                            style={{
                                                cursor: savedColect || updatedCollect ? 'auto' : 'pointer',
                                                transition: 'background-color 0.5s ease',
                                                width: formik.values?.id ? 'auto' : '135px',
                                                marginRight: '10px'
                                            }}
                                            type='submit'
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                        >
                                            {!formik.values?.id && (
                                            <>
                                                {saving ? 'Saving' : savedColect ? 'Saved as New' : 'Save as New'}
                                                {savingCollect && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                                </>
                                            )}
                                            {formik.values?.id && (
                                            <>
                                                {saving ? 'Saving' : updatedCollect ? 'Updated' : 'Update'}
                                                {savingCollect && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                                </>
                                            )}
                                        </button>
                                        <button
                                            className={`btn ${saved ? 'btn-success' : 'btn-primary'} d-flex align-items-center`}
                                            style={{
                                                cursor: saved ? 'auto' : 'pointer',
                                                transition: 'background-color 0.5s ease'
                                            }}
                                            type='button'
                                            onClick={async () => {
                                                formik.setTouched({
                                                    city: true,
                                                    zipcode: true,
                                                });
                                                
                                                setBillToData(formatCollectData(formik.values))
                                                formik.setFieldValue('billToData.zipcode', zipcode)
                                                const errors = await formik.validateForm()                                                
                                                formik.validateForm()
                                                if(Object.keys(errors).length === 0) {
                                                    setOpen(false)
                                                }
                                                else {
                                                  formik.setFieldError('zipcode', 'Required');
                                                }
                                            }}
                                        >
                                            {saved ? 'Saving' : saved ? 'Saved' : 'Save'}{saved && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                        </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                </DivPaperStyled>
            </Fade>
        </ModalStyled>
    )
}

export default EditOrAddModal